import { DocumentsViewComponent } from '@addins/documents/src/views/documents-view/documents-view.component';
import { Injectable } from '@angular/core';
import { MenuEntry } from '@services/menu/entry.schema';
import { SideMenuService } from '@services/menu/side-menu.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';

@AddinExecute({
  name: 'DocumentsMenu',
  description: 'Add a menu entry to list the documents'
})
@Injectable()
export class DocumentsMenuService extends Execute {
  private menuEntry: MenuEntry = null;

  constructor(private sideMenuService: SideMenuService) {
    super();
  }

  execute() {
    this.menuEntry = new MenuEntry('document', 'document', DocumentsViewComponent, 500);
    this.sideMenuService.addMenuEntry(this.menuEntry);
  }

  destroy() {
    if (this.menuEntry !== null) {
      this.sideMenuService.removeMenuEntry(this.menuEntry);
      this.menuEntry = null;
    }
  }
}
